import { render } from "./CDIDemand.component.vue?vue&type=template&id=53d950c8&scoped=true"
import script from "./CDIDemand.component.vue?vue&type=script&lang=js"
export * from "./CDIDemand.component.vue?vue&type=script&lang=js"

import "./CDIDemand.component.vue?vue&type=style&index=0&id=53d950c8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53d950c8"]])

export default __exports__